
import makerjs from "makerjs";
function B54(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,
    // T = Param[3].param,S1 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
       b = B * 1 * myZoom,       
       l = L * 1 * myZoom,       
      //  s1 = S1 * 1 * myZoom,       
       h = l,
       w = b,
       //hd=r-l,
       r=b/2,
       x0 = 0, x1 = 0, x2 =b ,x3 =b , 
       y0 = 0, y1 =l-r,y2 =l-r, y3 =0,glassH =h, glassW = l;
       if (b !== 0) {
        var TxtB ="B="+ B;
    }  if (l !== 0) {
     var TxtL = "L="+L;
   }
   var drawAbnormalShapeB54 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "LeftArcLine": new makerjs.paths.Arc([x1, y1], [x2,y2], r,false,true),
        "TopLine": new makerjs.paths.Line([x2,y2], [x3,y3]),
        "BottomLine": new makerjs.paths.Line([x3,y3],[0, 0]),
       }
   };
   var drawAbnormalShapeB54MarkB = {
       paths: {
        "bottomLine": new makerjs.paths.Line([0, -markShift], [b, -markShift]),        
        "RightShortUpline": new makerjs.paths.Line([0, 0], [0, -3*markShift]),
        "RightShortDnline": new makerjs.paths.Line([b, 0], [b, -3*markShift]),
       }  
   };
   var drawAbnormalShapeB54MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x1- markShift, l]),
        "RightShortUpline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
        "RightShortDnline": new makerjs.paths.Line([x1, l], [x1- 2 * markShift, l]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeB54MarkB, TxtB,  [0,-2*markShift], [b, -2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB54MarkL, TxtL,  [x0- 2*markShift, y0], [x1- 2*markShift, l]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB54: drawAbnormalShapeB54,
      }
    };
  markers={
      models: {
        drawAbnormalShapeB54: drawAbnormalShapeB54,
        drawAbnormalShapeB54MarkB:drawAbnormalShapeB54MarkB,
        drawAbnormalShapeB54MarkL:drawAbnormalShapeB54MarkL,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B54;